var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"titulo text text-h6 py-4"},[_vm._v("Precio Promedio")]),_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.chartOptions,"height":150}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }